export function seatOffset(realSeat, mySeat) {
  const arr = [1, 2, 3, 0, 1, 2, 3]; // 0 based indexing
  return arr[realSeat - mySeat + 3];
}
